export const appLanguages = [
  {
    language: "en",
    label: "English",
    flag: "🇺🇸",
  },
  {
    language: "fr",
    label: "French",
    flag: "🇫🇷",
  },
];
